import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { AppProvider, useTweaks } from '@/context/AppContext'
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import TweaksPanel, { TweakSection, TweakColor, TweakRadio, TweakToggle } from '@/components/TweaksPanel'
import HomePage from '@/pages/Home'
import AboutPage from '@/pages/About'
import ServicesPage from '@/pages/Services'
import ProjectsPage from '@/pages/Projects'
import EquipmentPage from '@/pages/Equipment'
import ClientsPage from '@/pages/Clients'
import GalleryPage from '@/pages/Gallery'
import ContactPage from '@/pages/Contact'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

function AppShell() {
  const [tweaks, setTweak] = useTweaks()

  return (
    <div>
      {tweaks.gridOverlay && <div className="grid-overlay" />}

      <Nav />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/equipment" element={<EquipmentPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/highlights" element={<GalleryPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>

      <Footer />

      <TweaksPanel>
        <TweakSection title="Accent">
          <TweakColor
            label="Brand accent"
            value={tweaks.accent}
            options={['#1B7B3F', '#155F31', '#2A8B47', '#0F0F0F', '#8C1C13']}
            onChange={(v) => setTweak('accent', v)}
          />
        </TweakSection>
        <TweakSection title="Layout">
          <TweakRadio
            label="Density"
            value={tweaks.density}
            options={[['comfortable', 'Comfortable'], ['compact', 'Compact']]}
            onChange={(v) => setTweak('density', v)}
          />
          <TweakToggle
            label="Blueprint grid overlay"
            value={tweaks.gridOverlay}
            onChange={(v) => setTweak('gridOverlay', v)}
          />
          <TweakToggle
            label="Uppercase display type"
            value={tweaks.uppercaseDisplay}
            onChange={(v) => setTweak('uppercaseDisplay', v)}
          />
        </TweakSection>
      </TweaksPanel>

      {tweaks.uppercaseDisplay && (
        <style>{`.display { text-transform: uppercase; letter-spacing: -0.015em !important; }`}</style>
      )}
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <ScrollToTop />
        <AppShell />
      </AppProvider>
    </BrowserRouter>
  )
}
